import { render, staticRenderFns } from "./single-review.vue?vue&type=template&id=9e7eeb20&scoped=true&"
import script from "./single-review.vue?vue&type=script&lang=js&"
export * from "./single-review.vue?vue&type=script&lang=js&"
import style0 from "./single-review.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./single-review.vue?vue&type=style&index=1&id=9e7eeb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7eeb20",
  null
  
)

export default component.exports